import HousesModel from '../../shared/packages/housesModel';
import { actionTypes } from '../constants';

const createInitialState = () => ({
  housesModel: new HousesModel(),
  search: '',
  selectedSearch: '',
  filter: undefined,
});

export const reducer = (state = createInitialState(), { type, payload }) => {
  switch (type) {
    case actionTypes.currentCompanyChanged:
    case actionTypes.currentCityChanged:
    case actionTypes.createReset: {
      return createInitialState();
    }

    case actionTypes.houseSearchChanged: {
      return { ...state, search: payload };
    }

    case actionTypes.houseSelectedSearchChanged: {
      return { ...state, selectedSearch: payload };
    }

    case actionTypes.houseFilterChanged: {
      return { ...state, filter: payload };
    }

    case actionTypes.houseSelected: {
      const housesModel = state.housesModel.clone();
      housesModel.addHouse(payload, { shouldCalculateValues: true });

      return { ...state, housesModel };
    }

    case actionTypes.houseDeselected: {
      const housesModel = state.housesModel.clone();
      housesModel.deleteHouse(payload, { shouldCalculateValues: true });

      return { ...state, housesModel };
    }

    case actionTypes.allHousesSelected: {
      const housesModel = state.housesModel.clone();
      housesModel.addHouses(payload);

      return { ...state, housesModel };
    }

    case actionTypes.allHousesDeselected: {
      const housesModel = state.housesModel.clone();
      housesModel.deleteHouses();

      return { ...state, housesModel };
    }

    case actionTypes.relationAdded: {
      const { room, relatedRooms } = payload;
      const housesModel = state.housesModel.clone();
      housesModel.addRelation(room, relatedRooms);

      return { ...state, housesModel };
    }

    case actionTypes.relationDeleted: {
      const housesModel = state.housesModel.clone();
      housesModel.deleteRelation(payload, { shouldCalculateValues: true });

      return { ...state, housesModel };
    }

    case actionTypes.roomFromRelationDeleted: {
      const housesModel = state.housesModel.clone();
      housesModel.deleteRoomFromRelation(payload, {
        shouldCalculateValues: true,
      });

      return { ...state, housesModel };
    }

    case actionTypes.roomsCountSet: {
      const housesModel = state.housesModel.clone();
      housesModel.setRoomCounts(payload);

      return { ...state, housesModel };
    }

    case actionTypes.roomIncluded: {
      const housesModel = state.housesModel.clone();
      housesModel.includeRoom(payload, { shouldCalculateValues: true });

      return { ...state, housesModel };
    }

    case actionTypes.roomExcluded: {
      const housesModel = state.housesModel.clone();
      housesModel.excludeRoom(payload, { shouldCalculateValues: true });

      return { ...state, housesModel };
    }

    case actionTypes.roomListIncluded: {
      const housesModel = state.housesModel.clone();
      housesModel.includeRooms(payload);

      return { ...state, housesModel };
    }

    case actionTypes.roomListExcluded: {
      const housesModel = state.housesModel.clone();
      housesModel.excludeRooms(payload);

      return { ...state, housesModel };
    }

    default:
      return state;
  }
};
